const getOtp = "/getOtp_client";
const verifyOtp = "/verifyOtp_common";

export { getOtp, verifyOtp };
